export const shopButtons = [
  { title: 'Shop Women', url: '/collections/womens' },
  { title: 'Shop Men', url: '/collections/mens' },
  { title: 'Shop Kids', url: '/collections/kids-socks' }
];

export default {};
